import { createFileRoute } from "@tanstack/react-router";
import BlogAlcoholRehabNewJerseyGuide from "@/pages/BlogAlcoholRehabNewJerseyGuide";
import { routeHead } from "@/lib/route-head";

export const Route = createFileRoute("/alcohol-rehab-new-jersey-guide")({
  head: () => routeHead("/alcohol-rehab-new-jersey-guide"),
  component: BlogAlcoholRehabNewJerseyGuide,
});
